<mat-expansion-panel class="flotante-panel" [expanded]="true">
  <mat-expansion-panel-header>
    <mat-panel-title>
      <mat-icon class="material-symbols-outlined">campaign</mat-icon>
      <span class="panel-title">Sirenas</span>
      <span class="counter-badge">{{ sirenasLength ?? 0 }}</span>
    </mat-panel-title>
  </mat-expansion-panel-header>

  <!-- CAPAS -->
  <div class="seccion">
    <div class="seccion-titulo">Capas</div>
    <div class="poligonos-pills">
      <div class="pill-item">
        <irx-segmentado
          class="visibility-toggle-group"
          tamano="compacto"
        >
          <irx-segmento
            (click)="onToggleCluster()"
            [activo]="clusterEnabled"
            [tooltip]="
              clusterEnabled ? 'Ocultar clusters' : 'Mostrar clusters'
            "
          >
            <mat-icon class="material-symbols-outlined">
              {{ clusterEnabled ? 'blur_on' : 'blur_off' }}
            </mat-icon>
          </irx-segmento>
        </irx-segmentado>
        <span class="pill-label">Mostrar</span>
      </div>
    </div>
  </div>

  <!-- ESTADOS (sólo conteo) -->
  <div class="seccion">
    <div class="seccion-titulo">Estados</div>
    <div class="estados-grid">
      <div class="capa-chip estado-chip solo-lectura">
        <span class="estado-icon-bg">
          <img src="assets/map/sirenas/verde.png" alt="" />
        </span>
        <span class="capa-label">Online</span>
        <span class="capa-count">{{ sirenasOnline ?? 0 }}</span>
      </div>
      <div class="capa-chip estado-chip solo-lectura">
        <span class="estado-icon-bg">
          <img src="assets/map/sirenas/roja.png" alt="" />
        </span>
        <span class="capa-label">Offline</span>
        <span class="capa-count">{{ sirenasOffline ?? 0 }}</span>
      </div>
    </div>
  </div>
</mat-expansion-panel>
